import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSwiper } from 'swiper/react';

const StyledButton = styled.button<{ isActive: boolean }>`
  ${({ theme, isActive }) => `
   width: 15px;
   height: 2px;
   background: ${isActive ? theme.colors.primary : theme.colors.lightGray};
   border-radius: 1px;
   margin-right: 6px;
   &:last-child {
     margin-right: 0;
   }
`}
`;

export default function Indicator() {
  const swiper = useSwiper();
  const [activeIndex, setActiveIndex] = useState(0);

  const swiperList: any[] = React.useMemo(() => (swiper.slides && swiper.slides.length > 0 ? swiper.slides : [0, 1]), [swiper.slides]);

  useEffect(() => {
    swiper.on('realIndexChange', () => {
      setActiveIndex(swiper.realIndex);
    });

    return () => {
      swiper.off('realIndexChange');
    };
  }, [swiper]);

  return (
    <div className="my-4 d-flex justify-content-center">
      {swiperList.map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <StyledButton key={`indicator-${index}`} className="btn p-0" isActive={activeIndex === index} onClick={() => swiper.slideTo(index)} />
      ))}
    </div>
  );
}
